import { render } from "./YUpload.vue?vue&type=template&id=aa804722&scoped=true"
import script from "./YUpload.vue?vue&type=script&lang=js"
export * from "./YUpload.vue?vue&type=script&lang=js"

import "./YUpload.vue?vue&type=style&index=0&id=aa804722&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa804722"]])

export default __exports__